/**
 * In the Spotlight — Bake Cosmetics
 * Asset: in-the-spotlight.js
 * Handles: tab switching, slider dot sync, add to cart
 */

(function () {
  'use strict';

  function initSpotlight(section) {
    const tabs = section.querySelectorAll('.spotlight-tab');
    const panels = section.querySelectorAll('.spotlight-panel');

    // ── Tab switching ───────────────────────────────────────────
    tabs.forEach((tab) => {
      tab.addEventListener('click', () => {
        const idx = parseInt(tab.dataset.tabIndex, 10);

        tabs.forEach((t) => {
          t.classList.remove('is-active');
          t.setAttribute('aria-selected', 'false');
        });
        panels.forEach((p) => {
          p.classList.remove('is-active');
          p.setAttribute('aria-hidden', 'true');
        });

        tab.classList.add('is-active');
        tab.setAttribute('aria-selected', 'true');

        const panel = panels[idx];
        if (panel) {
          panel.classList.add('is-active');
          panel.setAttribute('aria-hidden', 'false');
          // Reset slider scroll position when switching tabs
          const slider = panel.querySelector('.spotlight-slider');
          if (slider) slider.scrollLeft = 0;
          syncDots(panel);
        }
      });
    });

    // ── Dot sync on scroll ──────────────────────────────────────
    panels.forEach((panel) => {
      const slider = panel.querySelector('.spotlight-slider');
      if (!slider) return;

      slider.addEventListener('scroll', () => syncDots(panel), { passive: true });
      syncDots(panel);
    });

    function syncDots(panel) {
      const slider = panel.querySelector('.spotlight-slider');
      const dots = panel.querySelectorAll('.spotlight-dot');
      if (!slider || !dots.length) return;

      const cards = slider.querySelectorAll('.spotlight-card');
      if (!cards.length) return;

      // Cards visible at once (2 on mobile, more on desktop)
      const visibleCount = Math.round(slider.offsetWidth / cards[0].offsetWidth);
      const totalGroups = Math.ceil(cards.length / visibleCount);
      const scrollFraction = slider.scrollLeft / (slider.scrollWidth - slider.offsetWidth || 1);
      const activeDot = Math.round(scrollFraction * (totalGroups - 1));

      dots.forEach((dot, i) => {
        dot.classList.toggle('is-active', i === activeDot);
      });
    }

    // Dot click → scroll slider to that position
    panels.forEach((panel) => {
      const slider = panel.querySelector('.spotlight-slider');
      const dots = panel.querySelectorAll('.spotlight-dot');
      if (!slider || !dots.length) return;

      dots.forEach((dot, i) => {
        dot.addEventListener('click', () => {
          const cards = slider.querySelectorAll('.spotlight-card');
          if (!cards.length) return;
          const visibleCount = Math.round(slider.offsetWidth / cards[0].offsetWidth);
          const scrollTo = i * visibleCount * cards[0].offsetWidth;
          slider.scrollTo({ left: scrollTo, behavior: 'smooth' });
        });
      });
    });
  }

  // ── Add to Cart ──────────────────────────────────────────────
  window.spotlightAddToCart = async function (variantId, btn) {
    if (!variantId || btn.disabled) return;

    const originalText = btn.textContent;
    btn.disabled = true;
    btn.classList.add('loading');
    btn.textContent = 'Adding…';

    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 }),
      });

      if (!response.ok) throw new Error('Cart error');

      btn.textContent = 'Added ✓';
      btn.style.background = '#2a9d4e';

      // Refresh cart count bubble if theme supports it
      document.dispatchEvent(new CustomEvent('cart:refresh'));

      // Try to update Refresh theme cart count
      fetch('/cart.js')
        .then((r) => r.json())
        .then((cart) => {
          const bubble = document.querySelector('.cart-count-bubble span:first-child, #cart-icon-bubble span');
          if (bubble) bubble.textContent = cart.item_count;
        })
        .catch(() => {});

      setTimeout(() => {
        btn.textContent = originalText;
        btn.style.background = '';
        btn.disabled = false;
        btn.classList.remove('loading');
      }, 2000);
    } catch (e) {
      btn.textContent = 'Error – retry';
      btn.style.background = '#c0392b';
      setTimeout(() => {
        btn.textContent = originalText;
        btn.style.background = '';
        btn.disabled = false;
        btn.classList.remove('loading');
      }, 2000);
    }
  };

  // ── Init all sections on page ───────────────────────────────
  document.querySelectorAll('.spotlight-section').forEach(initSpotlight);
})();